var CONFIGURATION = (function () {
	var origin = location.origin;

	if (!window.location.origin) {
		origin = window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	}

	var SERVICE_URL = origin;

	var CLIENT_SERVICE_URL = SERVICE_URL + "/" + GLOBAL_LOCALE;

	var REST_URL = SERVICE_URL + '/rest';

	return {
		REST_URL: REST_URL,
		SERVICE_URL: SERVICE_URL,
		CLIENT_SERVICE_URL: CLIENT_SERVICE_URL
	};
})();